/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { defineComponent, onMounted, getCurrentInstance, createVNode } from 'vue';
import circleAdapter from '../../_common/js/loading/circle-adapter.mjs';
import { usePrefixClass } from '../../hooks/useConfig.mjs';
import '../../_chunks/dep-0b4c3c44.mjs';
import '../../_common/js/utils/set-style.mjs';
import '../../_common/js/utils/helper.mjs';
import '../../_chunks/dep-8c39d78a.mjs';
import '../../_chunks/dep-556a2f2c.mjs';
import '../../_chunks/dep-e68fd68c.mjs';
import '../../_chunks/dep-dcf624da.mjs';
import '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-bfb23a5e.mjs';
import '../../_chunks/dep-a48de419.mjs';
import '../../_chunks/dep-2a7dc5c7.mjs';
import '../../_chunks/dep-9311bf66.mjs';
import '../../_chunks/dep-4889eb51.mjs';
import '../../_chunks/dep-0b4185fe.mjs';
import '../../_chunks/dep-3ca5fb38.mjs';
import '../../_chunks/dep-7071345f.mjs';
import '../../_chunks/dep-d2403b2f.mjs';
import '../../_chunks/dep-7922050a.mjs';
import '../../_chunks/dep-169ea640.mjs';
import '../../_chunks/dep-f6b25712.mjs';
import '../../_chunks/dep-59545a4d.mjs';
import '../../_chunks/dep-c27b1c14.mjs';
import '../../_chunks/dep-7d96367f.mjs';
import '../../_chunks/dep-827c4600.mjs';
import '../../_chunks/dep-0820e0e2.mjs';
import '../../_chunks/dep-caad2e91.mjs';
import '../../_chunks/dep-3d4aad09.mjs';
import '../../_chunks/dep-8e38f523.mjs';
import '../../_chunks/dep-469bf54b.mjs';
import '../../_chunks/dep-8ef9fb8e.mjs';
import '../../_chunks/dep-e769aafd.mjs';
import '../../_chunks/dep-400798c5.mjs';
import '../../_chunks/dep-361522ee.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../config-provider/type.mjs';

var GradientIcon = defineComponent({
  name: "TLoadingGradient",
  setup: function setup() {
    var classPrefix = usePrefixClass();
    onMounted(function () {
      var circleElem = getCurrentInstance().refs.circle;
      circleAdapter(circleElem);
    });
    return {
      classPrefix: classPrefix
    };
  },
  render: function render() {
    var classPrefix = this.classPrefix;
    var name = "".concat(classPrefix, "-loading__gradient");
    var classes = [name, "".concat(classPrefix, "-icon-loading")];
    return createVNode("svg", {
      "class": classes,
      "viewBox": "0 0 14 14",
      "version": "1.1",
      "width": "1em",
      "height": "1em",
      "xmlns": "http://www.w3.org/2000/svg"
    }, [createVNode("foreignObject", {
      "x": "1",
      "y": "1",
      "width": "12",
      "height": "12"
    }, [createVNode("div", {
      "class": "".concat(name, "-conic"),
      "ref": "circle"
    }, null)])]);
  }
});

export { GradientIcon as default };
//# sourceMappingURL=gradient.mjs.map
